import React, { Component } from 'react'

import { Container } from 'components/Layout'
import BillingAddCreditCardForm from '../BillingAddCreditCardForm'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'

export default class BillingAddCreditCardFormModal extends Component {
  render() {
    const { modalConfirm, modalCancel, ban } = this.props
    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 20px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Add Credit Card</div>

          <BillingAddCreditCardForm onCancel={modalCancel} afterSubmit={modalConfirm} ban={ban} />
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddCreditCardFormModal/BillingAddCreditCardFormModal.jsx